import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api, formatTl, tokens } from '../lib/api';
import AraSec from '../ui/AraSec';
import { useAuth } from '../lib/auth';
import Ipucu from '../ui/Ipucu';
import HizliUrun from './HizliUrun';
import TanimliSecim from '../ui/TanimliSecim';
import { VadeCekmece, useVadeler } from '../ui/VadeTanim';
import { dosyaPaylas, useEylemCubugu, useTelefon } from '../ui/mobil';

type Satir = {
  anahtar: number;
  productId: number | null;
  code: string; name: string; imageUrl: string | null;
  listPriceKurus: number; discountPct: number; vatPct: number; qty: number;
  tavan: number | null; tavanKaynak?: string; marka?: string;
  unit?: string | null;
  stokResmi?: number | null; stokFaturasiz?: number | null;
  sonAlisKurus?: number | null;
  /** Yalnız kârı görebilen rolde gelir. */
  alisIskontoPct?: number | null; maliyetKurus?: number | null; maliyetKaynak?: string | null;
  /** true: bu teklife elle yazıldı (standart oran değil). */
  alisIskontoElle?: boolean;
  fiyatYok?: boolean;
};
type Cari = { id: number; name: string };
type Detay = {
  id: number; no: string; status: string; statusLabel: string;
  customer: { id: number; name: string } | null;
  customerFreetext: string | null;
  discountNote: string | null;
  vade: { id: string; ad: string; etiket: string } | null;
  hazirlayan: string | null; onaylayan: string | null; onayBekliyor: boolean;
  pdfVar: boolean;
  satirlar: (Satir & { netKurus: number; kdvKurus: number; overCap: boolean; tavanAsimiPuan: number | null })[];
  toplam: { araToplamKurus: number; kdvToplamKurus: number; genelToplamKurus: number; tavanAsanSayisi: number };
  ic?: { maliyetKurus: number; karKurus: number; karYuzde: number | null; maliyetiBilinmeyenSatir: number };
};

let sayac = 0;
const kurusToTl = (k: number) => (k / 100).toString();

/** Satır toplamı istemcide de aynı kuralla: yuvarlama bir kez, en sonda. */
const satirNet = (s: Satir) => Math.round(s.listPriceKurus * (1 - s.discountPct / 100) * s.qty);

export default function TeklifDetay() {
  const { id } = useParams();
  const git = useNavigate();
  const { can } = useAuth();
  const marjGorur = can('quote.cost') || can('quote.margin');

  const [d, setD] = useState<Detay | null>(null);
  const [satirlar, setSatirlar] = useState<Satir[]>([]);
  const [cariler, setCariler] = useState<Cari[]>([]);
  const [customerId, setCustomerId] = useState('');
  const [customerFreetext, setCustomerFreetext] = useState('');
  const [discountNote, setDiscountNote] = useState('');
  /** Vade listeden SEÇİLİR (nota yazılmaz); boş = belirtilmedi. Tanımlar Ayarlar'da. */
  const [vadeId, setVadeId] = useState('');
  const [vadeTanimAcik, setVadeTanimAcik] = useState(false);
  const { veri: vadeler, setVeri: setVadeler } = useVadeler();
  const [kodMetni, setKodMetni] = useState('');
  /* Yazdıkça öneri: virgülden sonraki son parça aranır (kod, ad ya da seri). */
  const [oneriler, setOneriler] = useState<{ id: number; code: string; name: string; notes: string | null; toplam: number; unit: string }[]>([]);
  const [oneriAraniyor, setOneriAraniyor] = useState(false);
  /** Dış katalog (tedarikçi listeleri): kendi stok kartımız olmayan markalı ürünler. */
  const [disOneri, setDisOneri] = useState<{ id: number; marka: string | null; kod: string; ad: string; gorselUrl: string | null; listeKurus: number | null }[]>([]);
  const [oneriSecili, setOneriSecili] = useState(0);
  const [oneriAcik, setOneriAcik] = useState(false);
  const sonParca = kodMetni.split(/[,;\n]/).pop() ?? '';
  const aranan = /\s[x*×%]|%/.test(sonParca) ? '' : sonParca.trim();
  useEffect(() => {
    if (aranan.length < 2) { setOneriler([]); setDisOneri([]); setOneriAraniyor(false); return; }
    setOneriAraniyor(true);
    let iptal = false;
    const t = setTimeout(() => {
      api<{ satirlar: typeof oneriler }>(`/api/urunler?ara=${encodeURIComponent(aranan)}&limit=8&sirala=kod`)
        .then((r) => { if (!iptal) { setOneriler(r.satirlar); setOneriSecili(0); setOneriAcik(true); } })
        .catch(() => { if (!iptal) setOneriler([]); })
        .finally(() => { if (!iptal) setOneriAraniyor(false); });
      api<{ urunler: typeof disOneri }>(`/api/katalog/ara?q=${encodeURIComponent(aranan)}`)
        .then((r) => { if (!iptal) { setDisOneri(r.urunler); setOneriAcik(true); } })
        .catch(() => { if (!iptal) setDisOneri([]); });
    }, 220);
    return () => { iptal = true; clearTimeout(t); };
  }, [aranan]);
  function oneriSec(kod: string) {
    const i = Math.max(kodMetni.lastIndexOf(','), kodMetni.lastIndexOf(';'), kodMetni.lastIndexOf('\n'));
    const bas = i >= 0 ? `${kodMetni.slice(0, i + 1)} ` : '';
    setOneriler([]); setOneriAcik(false);
    // Öneriden seçilen ürün DOĞRUDAN satıra eklenir (1 adet); adet ve iskonto satırda
    // düzeltilir. Kutuda önceden yazılmış başka kodlar varsa hepsi birlikte çözülür.
    void cozumle(`${bas}${kod}`);
    document.getElementById('kodlar')?.focus();
  }
  /** Dış katalogdan seçilen ürün doğrudan satır olur: kod, ad, görsel ve liste fiyatı katalogdan gelir. */
  function disSec(u: (typeof disOneri)[number]) {
    const i = Math.max(kodMetni.lastIndexOf(','), kodMetni.lastIndexOf(';'), kodMetni.lastIndexOf('\n'));
    setKodMetni(i >= 0 ? kodMetni.slice(0, i + 1) : '');
    setOneriler([]); setDisOneri([]); setOneriAcik(false);
    setSatirlar((s) => [...s, {
      anahtar: ++sayac, productId: null, code: u.kod, name: u.ad, imageUrl: u.gorselUrl,
      listPriceKurus: u.listeKurus ?? 0, discountPct: 0, vatPct: 20, qty: 1, tavan: null, marka: u.marka ?? undefined,
      unit: null, fiyatYok: u.listeKurus == null,
    }]);
    setBilgi(u.listeKurus == null ? `${u.kod} eklendi — katalogda fiyatı yok, liste fiyatını elle yazın` : `${u.kod} eklendi (katalogdan)`);
    document.getElementById('kodlar')?.focus();
  }
  const oneriGorunur = oneriAcik && aranan.length >= 2;
  const [bilinmeyen, setBilinmeyen] = useState<{ kod: string; adet: number | null; iskonto: number | null }[]>([]);
  const [hata, setHata] = useState<string | null>(null);
  const [bilgi, setBilgi] = useState<string | null>(null);
  const [fiyatUyarisi, setFiyatUyarisi] = useState<{ code: string; eskiKurus: number; yeniKurus: number }[]>([]);
  const [bekliyor, setBekliyor] = useState(false);
  const [pdfBekliyor, setPdfBekliyor] = useState(false);
  /** Kaydedilmemiş değişiklik var mı — olay işleyicileri güncel değeri buradan okur. */
  const kirliRef = useRef(false);
  const [hazirPdf, setHazirPdf] = useState<{ blob: Blob; ad: string } | null>(null);
  /* Telefon düzeni: satırlar kart, altta sabit toplam + Kaydet + PDF. */
  const telefon = useTelefon();
  useEylemCubugu(telefon && d != null);

  const yukle = useCallback(async () => {
    const t = await api<Detay>(`/api/teklif/${id}`);
    setD(t);
    setSatirlar(t.satirlar.map((s) => ({ ...s, anahtar: ++sayac })));
    setCustomerId(t.customer ? String(t.customer.id) : '');
    setCustomerFreetext(t.customerFreetext ?? '');
    setDiscountNote(t.discountNote ?? '');
    setVadeId(t.vade?.id ?? '');
  }, [id]);

  useEffect(() => {
    yukle().catch((e) => setHata((e as Error).message));
    api<{ cariler: Cari[] }>('/api/cariler').then((r) => setCariler(r.cariler)).catch(() => undefined);
  }, [yukle]);

  const yazabilir = can('quote.write') && d?.status !== 'ONAYLANDI' && d?.status !== 'KAYBEDILDI';

  function guncelle(anahtar: number, alan: Partial<Satir>) {
    setSatirlar((s) => s.map((x) => (x.anahtar === anahtar ? { ...x, ...alan } : x)));
  }

  /* ─── Kod yapıştır → satır ─────────────────────────────────────────── */
  async function cozumle(metinVerilen?: string) {
    const metin = metinVerilen ?? kodMetni;
    if (!metin.trim()) return;
    setHata(null);
    try {
      const r = await api<{ satirlar: Omit<Satir, 'anahtar'>[]; bilinmeyen: typeof bilinmeyen }>(
        '/api/teklif/cozumle', { method: 'POST', body: JSON.stringify({ metin }) }
      );
      setSatirlar((s) => [...s, ...r.satirlar.map((x) => ({ ...x, anahtar: ++sayac }))]);
      setBilinmeyen(r.bilinmeyen);
      setKodMetni('');
      if (r.satirlar.length) setBilgi(`${r.satirlar.length} satır eklendi`);
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'Çözümlenemedi');
    }
  }

  /** Dönüş: kayıt başarılı mı. PDF ve durum düğmeleri önce bunu çağırır. */
  async function kaydet(): Promise<boolean> {
    setHata(null); setBilgi(null); setBekliyor(true);
    try {
      const r = await api<{ onayBekliyor: boolean; toplam: Detay['toplam'] }>(`/api/teklif/${id}`, {
        method: 'PUT',
        body: JSON.stringify({
          customerId: customerId ? Number(customerId) : null,
          customerFreetext: customerId ? null : (customerFreetext || null),
          discountNote: discountNote || null,
          vadeId: vadeId || null,
          satirlar: satirlar.map((s) => ({
            productId: s.productId, freetextCode: s.productId ? undefined : s.code,
            name: s.name, imageUrl: s.imageUrl ?? undefined,
            listPriceKurus: s.listPriceKurus, discountPct: s.discountPct,
            vatPct: s.vatPct, qty: s.qty,
            // Standart oran sunucuda zaten biliniyor; yalnız elle yazılan saklanır.
            ...(marjGorur ? { purchaseDiscountPct: s.alisIskontoElle && s.alisIskontoPct != null ? s.alisIskontoPct : null } : {}),
          })),
        }),
      });
      setBilgi(r.onayBekliyor
        ? 'Kaydedildi · tavan aşan satır var, yetkiliye bildirim gitti'
        : 'Kaydedildi');
      await yukle();
      return true;
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'Kaydedilemedi');
      return false;
    } finally {
      setBekliyor(false);
    }
  }

  async function durumDegistir(status: string) {
    setHata(null);
    // Kaydedilmemiş değişiklik varsa ÖNCE kaydet: eskiden değişiklikler
    // sessizce siliniyor, yeni teklifte "boş teklif" hatası çıkıyordu.
    if (kirliRef.current && !(await kaydet())) return;
    try {
      await api(`/api/teklif/${id}/durum`, { method: 'POST', body: JSON.stringify({ status }) });
      await yukle();
      setBilgi('Durum güncellendi');
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'Durum değiştirilemedi');
    }
  }

  /** Teklif → Sipariş. Kaydedilmemiş değişiklik varsa önce kaydeder. */
  async function sipariseDonustur() {
    setHata(null);
    if (kirliRef.current && !(await kaydet())) return;
    if (!window.confirm('Bu teklif onaylanıp siparişe dönüştürülsün mü?')) return;
    try {
      const r = await api<{ no: string }>(`/api/siparis/tekliften/${id}`, { method: 'POST' });
      git('/siparis', { state: { bilgi: `${r.no} siparişi açıldı` } });
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'Siparişe dönüştürülemedi');
    }
  }

  async function kopyala() {
    try {
      const r = await api<{ id: number; no: string; degisenler: typeof fiyatUyarisi }>(
        `/api/teklif/${id}/kopyala`, { method: 'POST' }
      );
      setFiyatUyarisi(r.degisenler);
      git(`/teklif/${r.id}`, { state: { degisenler: r.degisenler } });
      setBilgi(`${r.no} olarak kopyalandı`);
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'Kopyalanamadı');
    }
  }

  /** PDF'i yetkilendirilmiş indir — <a href> token taşıyamaz. */
  async function pdfIndir(musteriKopyasi: boolean) {
    // PDF sunucudaki KAYITLI hâli basar. Ekranda kaydedilmemiş değişiklik
    // varsa önce kaydedilir; yoksa müşteriye eski rakamlı PDF giderdi.
    if (kirliRef.current && !(await kaydet())) return;
    setPdfBekliyor(true); setHata(null);
    try {
      const res = await fetch(`/api/teklif/${id}/pdf${musteriKopyasi ? '' : '?ic=1'}`, {
        headers: tokens.access ? { authorization: `Bearer ${tokens.access}` } : {},
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error((j as { error?: string }).error ?? 'PDF oluşturulamadı');
      }
      const blob = await res.blob();
      const ad = `Teklif-${d?.no ?? id}${musteriKopyasi ? '' : '-ic'}.pdf`;
      // Telefon: PDF doğrudan paylaşım sayfasına verilir (WhatsApp, e-posta, Dosyalar). Desteklenmiyorsa indirilir.
      const sonuc = await dosyaPaylas(blob, ad, `Teklif ${d?.no ?? ''}`);
      if (sonuc === 'paylasildi' || sonuc === 'vazgecti') return;
      // iOS: dosya hazırlanırken dokunuşun süresi doldu. Dosya elde tutulur, "Paylaş" düğmesi tek dokunuşla açar.
      if (sonuc === 'izin') { setHazirPdf({ blob, ad }); return; }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = ad;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'PDF oluşturulamadı');
    } finally {
      setPdfBekliyor(false);
    }
  }

  if (!d) {
    return hata
      ? <div className="ccd-banner ccd-banner-danger"><span className="ccd-banner-icon">!</span><span>{hata}</span></div>
      : <div className="ccd-inline-note">Yükleniyor…</div>;
  }

  /**
   * Kaydedilmemiş değişiklik var mı? İç görünümdeki maliyet/kâr SUNUCUDAN
   * gelir ve kayıtlı hâli yansıtır; ekrandaki satırlar değişmişken o rakamı
   * göstermek yanlış karar verdirir.
   */
  const kirli = JSON.stringify(
    satirlar.map((s) => [s.productId, s.code, s.listPriceKurus, s.discountPct, s.vatPct, s.qty])
  ) !== JSON.stringify(
    d.satirlar.map((s) => [s.productId, s.code, s.listPriceKurus, s.discountPct, s.vatPct, s.qty])
  ) || vadeId !== (d.vade?.id ?? '');

  kirliRef.current = kirli && Boolean(yazabilir);

  /* Canlı toplamlar — kaydetmeden önce de doğru görünsün. */
  const araToplam = satirlar.reduce((t, s) => t + satirNet(s), 0);
  const kdvToplam = satirlar.reduce((t, s) => t + Math.round(satirNet(s) * (s.vatPct / 100)), 0);
  const tavanAsan = satirlar.filter((s) => s.tavan != null && s.discountPct > s.tavan).length;

  return (
    <>
      <div className="ccd-row-between" style={{ flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div className="ccd-eyebrow">
            <button className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={() => git('/teklif')}>
              ← Teklifler
            </button>
          </div>
          <h1 className="ccd-title">
            Teklif <span className="ccd-mono">{d.no}</span> · {d.statusLabel.toLowerCase()}
          </h1>
          <div className="ccd-meta">
            {d.customer?.name ?? d.customerFreetext ?? 'cari seçilmedi'}
            {d.hazirlayan ? ` · hazırlayan: ${d.hazirlayan}` : ''}
            {d.onaylayan ? ` · onay: ${d.onaylayan}` : ''}
          </div>
        </div>
        <div className="ccd-row" style={{ flexWrap: 'wrap' }}>
          {can('quote.write') && (
            <button className="ccd-btn ccd-btn-sm" onClick={kopyala}>Teklifi kopyala</button>
          )}
          {can('order.write') && (
            <button className="ccd-btn ccd-btn-accent ccd-btn-sm" onClick={sipariseDonustur}
                    title="Teklif onaylanır ve sipariş hattında sipariş açılır">Siparişe dönüştür</button>
          )}
          {can('quote.cost') && (
            <button className="ccd-btn ccd-btn-sm" onClick={() => pdfIndir(false)} disabled={pdfBekliyor}>
              İç kopya (maliyetli)
            </button>
          )}
          <button className="ccd-btn ccd-btn-primary ccd-btn-sm" data-tur="pdf"
                  onClick={() => pdfIndir(true)} disabled={pdfBekliyor}>
            {pdfBekliyor ? 'Hazırlanıyor…' : 'PDF Oluştur'}
          </button>
        </div>
      </div>

      {bilgi && (
        <div className="ccd-banner">
          <span className="ccd-banner-icon" aria-hidden="true">✓</span><span>{bilgi}</span>
        </div>
      )}
      {hata && (
        <div className="ccd-banner ccd-banner-danger">
          <span className="ccd-banner-icon" aria-hidden="true">!</span><span>{hata}</span>
        </div>
      )}
      {fiyatUyarisi.length > 0 && (
        <div className="ccd-banner ccd-banner-warning">
          <span className="ccd-banner-icon" aria-hidden="true">₺</span>
          <div>
            <div style={{ fontWeight: 600 }}>{fiyatUyarisi.length} satırın liste fiyatı değişmişti</div>
            <div className="ccd-meta">
              {fiyatUyarisi.map((f) => `${f.code}: ${formatTl(f.eskiKurus)} → ${formatTl(f.yeniKurus)}`).join(' · ')}
            </div>
          </div>
        </div>
      )}
      {d.onayBekliyor && (
        <div className="ccd-banner ccd-banner-danger">
          <span className="ccd-banner-icon" aria-hidden="true">!</span>
          <div>
            <div style={{ fontWeight: 600 }}>İskonto tavanı aşıldı · yetkili onayı yok</div>
            <div className="ccd-meta">
              Teklif kaydedildi ve kullanılabilir — tavan engellemez. Yetkili açıp kaydettiğinde onay düşer.
            </div>
          </div>
        </div>
      )}

      {/* Cari */}
      <div className="ccd-card ccd-stack-sm">
        <div className="ccd-form-grid">
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="cari">Cari</label>
            <AraSec id="cari" data-tur="cari" deger={customerId} degis={setCustomerId} disabled={!yazabilir}
                    secenekler={cariler.map((c) => ({ id: c.id, ad: c.name }))}
                    yerTutucu="Cari adı yazın…" bosEtiket="— kayıtsız cari —" />
          </div>
          {!customerId && (
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="cserbest">Cari adı (kayıtsız)</label>
              <input id="cserbest" className="ccd-input" value={customerFreetext} disabled={!yazabilir}
                     onChange={(e) => setCustomerFreetext(e.target.value)}
                     placeholder="Nilüfer Mimarlık" />
            </div>
          )}
        </div>
        <div className="ccd-form-grid">
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="vade">Vade</label>
            <TanimliSecim id="vade" data-tur="vade" deger={vadeId} degis={setVadeId} disabled={!yazabilir} yukleniyor={!vadeler}
                          secenekler={(vadeler?.secenekler ?? []).map((s) => ({ id: s.id, ad: s.ad }))}
                          bosEtiket="— belirtilmedi —" ekSecenek={d.vade ? { id: d.vade.id, ad: d.vade.ad } : null}
                          tanimlayabilir={can('settings.write')} yeniTanimla={() => setVadeTanimAcik(true)} yeniEtiket="+ Yeni vade tanımla…" />
            <div className="ccd-field-hint">
              PDF'te "Ödeme" satırı olarak çıkar; sipariş açılınca ödeme planına döner ve vadesi gelince hatırlatılır.
            </div>
          </div>
          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="isknot">Teklif notu</label>
            <input id="isknot" className="ccd-input" value={discountNote} disabled={!yazabilir}
                   onChange={(e) => setDiscountNote(e.target.value)}
                   placeholder="Nakliye dahil · teslim 2 hafta" />
            <div className="ccd-field-hint">PDF'in altında müşteriye de görünür. Vadeyi buraya yazmayın; yandaki listeden seçin.</div>
          </div>
        </div>
      </div>

      {/* Kod yapıştır */}
      {yazabilir && (
        <div className="ccd-card">
          <div className="ccd-row" style={{ alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div className="ccd-field ccd-tk-ekle" style={{ flex: '1 1 320px', position: 'relative' }} data-klavye-ust>
              <label className="ccd-field-label" htmlFor="kodlar">
                Kod ekle — tek tek veya toplu yapıştır
              </label>
              <input id="kodlar" className="ccd-input ccd-mono" data-tur="kodlar" value={kodMetni}
                     autoComplete="off" autoCapitalize="none" autoCorrect="off" spellCheck={false} enterKeyHint="search"
                     role="combobox" aria-expanded={oneriGorunur} aria-controls="kod-oneri"
                     onChange={(e) => { setKodMetni(e.target.value); setOneriAcik(true); }}
                     onBlur={() => setTimeout(() => setOneriAcik(false), 150)}
                     onKeyDown={(e) => {
                       const acik = oneriGorunur && oneriler.length > 0;
                       if (acik && e.key === 'ArrowDown') { e.preventDefault(); setOneriSecili((n) => (n + 1) % oneriler.length); }
                       else if (acik && e.key === 'ArrowUp') { e.preventDefault(); setOneriSecili((n) => (n - 1 + oneriler.length) % oneriler.length); }
                       else if (acik && (e.key === 'Enter' || e.key === 'Tab')) { e.preventDefault(); oneriSec(oneriler[oneriSecili].code); }
                       else if (e.key === 'Escape') setOneriAcik(false);
                       else if (e.key === 'Enter') { e.preventDefault(); void cozumle(); }
                     }}
                     placeholder="Kod ya da ürün adı yazın — ARTBMRN7530G x6 %45, ARTFDG1030M x40" />
              {oneriGorunur && (
                <div id="kod-oneri" role="listbox" className="ccd-oneri">
                  {oneriAraniyor && oneriler.length === 0 ? (
                    <div className="ccd-oneri-bos"><span className="ccd-oneri-donen" /> Aranıyor…</div>
                  ) : oneriler.length === 0 && disOneri.length === 0 ? (
                    <div className="ccd-oneri-bos">“{aranan}” ile eşleşen ürün yok</div>
                  ) : oneriler.map((o, n) => (
                    <button key={o.id} type="button" role="option" aria-selected={n === oneriSecili}
                            className={`ccd-oneri-satir ccd-oneri-urun${n === oneriSecili ? ' ccd-is-active' : ''}`}
                            onMouseEnter={() => setOneriSecili(n)}
                            onMouseDown={(e) => { e.preventDefault(); oneriSec(o.code); }}>
                      <span className="ccd-mono">{o.code}</span>
                      <span className="ccd-oneri-ad">{o.name}{o.notes ? <span className="ccd-muted"> · {o.notes}</span> : null}</span>
                      <span className="ccd-muted ccd-oneri-sag">stok {o.toplam}</span>
                    </button>
                  ))}
                  {disOneri.length > 0 && <div className="ccd-oneri-baslik">Tedarikçi kataloğu</div>}
                  {disOneri.map((u) => (
                    <button key={`dis-${u.id}`} type="button" role="option" aria-selected={false} className="ccd-oneri-satir ccd-oneri-urun"
                            onMouseDown={(e) => { e.preventDefault(); disSec(u); }}>
                      {u.gorselUrl ? <img src={u.gorselUrl} alt="" className="ccd-oneri-gorsel" loading="lazy" /> : <span className="ccd-oneri-gorsel" />}
                      <span className="ccd-mono">{u.kod}</span>
                      <span className="ccd-oneri-ad">{u.ad}</span>
                      <span className="ccd-muted ccd-oneri-sag">{u.listeKurus == null ? 'fiyat yok' : formatTl(u.listeKurus)}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button className="ccd-btn ccd-btn-accent" onClick={() => void cozumle()}>Satırlara Dönüştür</button>
          </div>
          <div className="ccd-field-hint" style={{ marginTop: 6 }}>
            Adet <span className="ccd-mono">x6</span>, iskonto <span className="ccd-mono">%45</span> olarak
            yazılabilir. İskonto yazılmazsa ürünün tavanı uygulanır. Tedarikçi kodu da tanınır.
            Yazdıkça ürünler listelenir; ↑ ↓ ile seçip Enter'a basınca ürün satıra eklenir.
          </div>
        </div>
      )}

      {bilinmeyen.length > 0 && (
        <div className="ccd-banner ccd-banner-warning">
          <span className="ccd-banner-icon" aria-hidden="true">?</span>
          <div className="ccd-stack-sm">
            <div style={{ fontWeight: 600 }}>{bilinmeyen.length} kod tanınmadı</div>
            <div className="ccd-row" style={{ flexWrap: 'wrap' }}>
              {bilinmeyen.map((b) => (
                <span key={b.kod} className="ccd-mono ccd-badge">{b.kod}</span>
              ))}
            </div>
            {can('product.write') && (
              <div className="ccd-meta">
                Aşağıdan tanımlayın — bir daha sorulmaz.
              </div>
            )}
          </div>
        </div>
      )}
      {bilinmeyen.length > 0 && can('product.write') && (
        <HizliUrun
          kalem={bilinmeyen[0]}
          kapat={() => setBilinmeyen((b) => b.slice(1))}
          eklendi={(satir) => {
            setSatirlar((s) => [...s, { ...satir, anahtar: ++sayac }]);
            setBilinmeyen((b) => b.slice(1));
          }}
        />
      )}

      {/* Satırlar */}
      {satirlar.length === 0 ? (
        <div className="ccd-empty">Henüz satır yok. Yukarıya ürün kodu yapıştırın.</div>
      ) : telefon ? (
        /* Telefon: her satır bir kart — adet ± düğmeleri, iskonto, liste fiyatı, tutar. */
        <ul className="ccd-tk-liste">
          {satirlar.map((s) => {
            const asti = s.tavan != null && s.discountPct > s.tavan;
            const adetDegis = (fark: number) => guncelle(s.anahtar, { qty: Math.max(0, Math.round((s.qty + fark) * 1000) / 1000) });
            const sayi = (v: string) => Number(v.replace(',', '.') || 0);
            const birim = s.alisIskontoPct != null && (s.alisIskontoElle || s.maliyetKaynak !== 'son alış faturası')
              ? Math.round(s.listPriceKurus * (1 - s.alisIskontoPct / 100)) : s.maliyetKurus ?? null;
            const kar = birim == null ? null : satirNet(s) - Math.round(birim * s.qty);
            return (
              <li key={s.anahtar} className="ccd-tk-kart">
                <div className="ccd-tk-ust">
                  {s.imageUrl
                    ? <img src={s.imageUrl} alt="" width={44} height={44} className="ccd-tk-gorsel" />
                    : <span className="ccd-avatar ccd-tk-gorsel">{(s.code || s.name).charAt(0)}</span>}
                  <div className="ccd-tk-ad">
                    <b className="ccd-mono">{s.code || '—'}</b>
                    <span>{s.name}</span>
                    <span className="ccd-meta">
                      {s.stokResmi != null && <>stok {s.stokResmi + (s.stokFaturasiz ?? 0)}</>}
                      {s.fiyatYok && <span className="ccd-kpi-down">{s.stokResmi != null ? ' · ' : ''}liste fiyatı yok</span>}
                    </span>
                  </div>
                  {yazabilir && (
                    <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-icon" aria-label={`${s.code || s.name} satırını sil`}
                            onClick={() => setSatirlar((x) => x.filter((y) => y.anahtar !== s.anahtar))}>✕</button>
                  )}
                </div>
                <div className="ccd-tk-adet">
                  <span className="ccd-tk-etiket">Adet</span>
                  <div className="ccd-tk-sayac">
                    <button type="button" className="ccd-btn" disabled={!yazabilir || s.qty <= 0} aria-label="Adedi bir azalt" onClick={() => adetDegis(-1)}>−</button>
                    <input className="ccd-input" inputMode="decimal" autoComplete="off" disabled={!yazabilir} aria-label={`${s.code || s.name} adet`}
                           value={String(s.qty).replace('.', ',')} onFocus={(e) => e.target.select()}
                           onChange={(e) => guncelle(s.anahtar, { qty: sayi(e.target.value) })} />
                    <button type="button" className="ccd-btn" disabled={!yazabilir} aria-label="Adedi bir artır" onClick={() => adetDegis(1)}>+</button>
                  </div>
                </div>
                <div className="ccd-tk-alanlar">
                  <label className="ccd-tk-alan">
                    <span className="ccd-tk-etiket">Liste ₺</span>
                    <input className="ccd-input" inputMode="decimal" autoComplete="off" disabled={!yazabilir}
                           value={kurusToTl(s.listPriceKurus).replace('.', ',')} onFocus={(e) => e.target.select()}
                           onChange={(e) => guncelle(s.anahtar, { listPriceKurus: Math.round(sayi(e.target.value) * 100) })} />
                  </label>
                  <label className="ccd-tk-alan">
                    <span className="ccd-tk-etiket">{marjGorur ? 'Satış isk. %' : 'İskonto %'}</span>
                    <input className="ccd-input" inputMode="decimal" autoComplete="off" disabled={!yazabilir}
                           style={asti ? { color: 'var(--ccd-danger)', fontWeight: 700 } : undefined}
                           value={String(s.discountPct).replace('.', ',')} onFocus={(e) => e.target.select()}
                           onChange={(e) => guncelle(s.anahtar, { discountPct: Math.min(100, Math.max(0, sayi(e.target.value))) })} />
                  </label>
                  {marjGorur && (
                    <label className="ccd-tk-alan">
                      <span className="ccd-tk-etiket">Alış isk. %{s.alisIskontoElle ? ' (elle)' : ''}</span>
                      <input className="ccd-input" inputMode="decimal" autoComplete="off" disabled={!yazabilir} placeholder="—"
                             value={s.alisIskontoPct == null ? '' : String(s.alisIskontoPct).replace('.', ',')} onFocus={(e) => e.target.select()}
                             onChange={(e) => guncelle(s.anahtar, e.target.value === ''
                               ? { alisIskontoPct: null, alisIskontoElle: false }
                               : { alisIskontoPct: sayi(e.target.value), alisIskontoElle: true })} />
                    </label>
                  )}
                </div>
                <div className="ccd-tk-alt">
                  <span>
                    {s.tavan == null ? <span className="ccd-muted">tavan yok</span>
                      : asti ? <span className="ccd-badge ccd-badge-danger">tavan %{s.tavan} aşıldı!</span>
                      : <span className="ccd-badge ccd-badge-success">tavan %{s.tavan} ✓</span>}
                    {marjGorur && (kar == null ? <span className="ccd-muted"> · kâr bilinmiyor</span>
                      : <span className={kar >= 0 ? 'ccd-kpi-up' : 'ccd-kpi-down'}> · kâr {formatTl(kar)}</span>)}
                  </span>
                  <b className="ccd-tk-tutar">{formatTl(satirNet(s))}</b>
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="ccd-table-wrap">
          <table className="ccd-table">
            <thead>
              <tr>
                <th className="ccd-th" style={{ width: 54 }}>Görsel</th>
                <th className="ccd-th">Kod / Ürün</th>
                <th className="ccd-th ccd-td-num">Liste ₺ <Ipucu id="teklif-toplam" /></th>
                <th className="ccd-th ccd-td-num">{marjGorur ? 'Satış isk. %' : 'İskonto %'} <Ipucu id="satis-iskontosu" /></th>
                <th className="ccd-th ccd-td-num">Adet</th>
                <th className="ccd-th ccd-td-num">Tutar ₺ <Ipucu id="teklif-toplam" /></th>
                {marjGorur && <th className="ccd-th ccd-td-num">Alış isk. % <Ipucu id="alis-iskontosu" /></th>}
                {marjGorur && <th className="ccd-th ccd-td-num">Kâr <Ipucu id="kar-marj" /></th>}
                <th className="ccd-th">Tavan <Ipucu id="iskonto-tavani" /></th>
                {yazabilir && <th className="ccd-th" />}
              </tr>
            </thead>
            <tbody>
              {satirlar.map((s) => {
                const asti = s.tavan != null && s.discountPct > s.tavan;
                return (
                  <tr key={s.anahtar} className="ccd-tr">
                    <td className="ccd-td">
                      {s.imageUrl
                        ? <img src={s.imageUrl} alt="" width={36} height={36}
                               style={{ borderRadius: 8, objectFit: 'cover' }} />
                        : <span className="ccd-avatar" style={{ borderRadius: 8 }}>
                            {(s.code || s.name).charAt(0)}
                          </span>}
                    </td>
                    <td className="ccd-td">
                      <b className="ccd-mono">{s.code || '—'}</b>
                      <div className="ccd-meta">
                        {s.name}
                        {s.fiyatYok && <span className="ccd-kpi-down"> · liste fiyatı yok</span>}
                        {s.stokResmi != null && (
                          <> · stok: {s.stokResmi + (s.stokFaturasiz ?? 0)}</>
                        )}
                      </div>
                    </td>
                    <td className="ccd-td ccd-td-num">
                      <input className="ccd-input ccd-td-num" type="number" inputMode="decimal" step="any" disabled={!yazabilir}
                             style={{ width: 110, textAlign: 'right' }}
                             value={kurusToTl(s.listPriceKurus)}
                             onChange={(e) => guncelle(s.anahtar, {
                               listPriceKurus: Math.round(Number(e.target.value || 0) * 100),
                             })} />
                    </td>
                    <td className="ccd-td ccd-td-num">
                      <input className="ccd-input" type="number" inputMode="decimal" step="any" min={0} max={100} disabled={!yazabilir}
                             style={{
                               width: 76, textAlign: 'right',
                               ...(asti ? { color: 'var(--ccd-danger)', fontWeight: 700 } : {}),
                             }}
                             value={s.discountPct}
                             onChange={(e) => guncelle(s.anahtar, { discountPct: Number(e.target.value || 0) })} />
                    </td>
                    <td className="ccd-td ccd-td-num">
                      <input className="ccd-input" type="number" inputMode="decimal" step="any" min={0} disabled={!yazabilir}
                             style={{ width: 76, textAlign: 'right' }}
                             value={s.qty}
                             onChange={(e) => guncelle(s.anahtar, { qty: Number(e.target.value || 0) })} />
                    </td>
                    <td className="ccd-td ccd-td-num"><b>{formatTl(satirNet(s))}</b></td>
                    {marjGorur && (
                      <td className="ccd-td ccd-td-num">
                        <input className="ccd-input" type="number" inputMode="decimal" step="any" min={0} max={100} disabled={!yazabilir}
                               style={{ width: 76, textAlign: 'right', ...(s.alisIskontoElle ? { fontWeight: 700 } : {}) }}
                               title={s.alisIskontoElle ? 'Bu teklife elle yazıldı. Boşaltıp kaydederseniz standart orana döner.' : 'Markanın standart alış iskontosu. Özel alım için değiştirin.'}
                               placeholder="—" value={s.alisIskontoPct ?? ''}
                               onChange={(e) => guncelle(s.anahtar, e.target.value === ''
                                 ? { alisIskontoPct: null, alisIskontoElle: false }
                                 : { alisIskontoPct: Number(e.target.value), alisIskontoElle: true })} />
                        {s.alisIskontoElle && <div className="ccd-meta">elle</div>}
                      </td>
                    )}
                    {marjGorur && (() => {
                      // Liste fiyatı elle değiştiyse iskontodan türeyen maliyet de onunla değişir.
                      // Elle yazılan ya da standart alış iskontosu varsa maliyet ondan; yoksa son alış faturası.
                      const birim = s.alisIskontoPct != null && (s.alisIskontoElle || s.maliyetKaynak !== 'son alış faturası')
                        ? Math.round(s.listPriceKurus * (1 - s.alisIskontoPct / 100)) : s.maliyetKurus ?? null;
                      if (birim == null) return <td className="ccd-td ccd-td-num"><span className="ccd-muted" title="Alış fiyatı ve alış iskontosu bilinmiyor">bilinmiyor</span></td>;
                      const kar = satirNet(s) - Math.round(birim * s.qty);
                      const pct = satirNet(s) > 0 ? Math.round((kar / satirNet(s)) * 100) : null;
                      return (
                        <td className="ccd-td ccd-td-num" title={`Tahmini maliyet ${formatTl(Math.round(birim * s.qty))} · kaynak: ${s.maliyetKaynak ?? '—'}`}>
                          <b className={kar >= 0 ? 'ccd-kpi-up' : 'ccd-kpi-down'}>{formatTl(kar)}</b>
                          {pct != null && <div className="ccd-meta">%{pct}</div>}
                        </td>
                      );
                    })()}
                    <td className="ccd-td ccd-td-nowrap">
                      {s.tavan == null ? (
                        <span className="ccd-muted">tavan yok</span>
                      ) : asti ? (
                        <span className="ccd-badge ccd-badge-danger">
                          tavan %{s.tavan} aşıldı!
                        </span>
                      ) : (
                        <span className="ccd-badge ccd-badge-success">tavan %{s.tavan} ✓</span>
                      )}
                    </td>
                    {yazabilir && (
                      <td className="ccd-td">
                        <button className="ccd-btn ccd-btn-ghost ccd-btn-sm"
                                onClick={() => setSatirlar((x) => x.filter((y) => y.anahtar !== s.anahtar))}>
                          Sil
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Toplamlar — şartname 4.3: ara toplam → KDV → genel toplam */}
      <div className="ccd-card">
        <div className="ccd-row-between" style={{ flexWrap: 'wrap', gap: 16 }}>
          <div className="ccd-stack-sm">
            {marjGorur && (() => {
              /* Kâr özeti canlı: satış ya da alış iskontosu değiştikçe kaydetmeden güncellenir. */
              let ciro = 0, maliyet = 0, bilinmeyen = 0;
              for (const x of satirlar) {
                const net = satirNet(x);
                const birim = x.alisIskontoPct != null && (x.alisIskontoElle || x.maliyetKaynak !== 'son alış faturası')
                  ? Math.round(x.listPriceKurus * (1 - x.alisIskontoPct / 100)) : x.maliyetKurus ?? null;
                if (birim == null) { bilinmeyen += 1; continue; }
                ciro += net; maliyet += Math.round(birim * x.qty);
              }
              if (satirlar.length === 0) return null;
              if (bilinmeyen === satirlar.length) {
                return <span className="ccd-muted">Kâr: satırların alış iskontosu bilinmiyor — <b>Alış isk. %</b> sütununa yazın, kâr hemen hesaplanır.</span>;
              }
              const kar = ciro - maliyet;
              return (
                <span data-fihrist="kar-marj">
                  Tahmini maliyet {formatTl(maliyet)} ·{' '}
                  <b className={kar >= 0 ? 'ccd-kpi-up' : 'ccd-kpi-down'} style={{ fontSize: 18 }}>
                    Kâr {formatTl(kar)}{ciro > 0 ? ` (%${Math.round((kar / ciro) * 100)})` : ''}
                  </b>{' '}<Ipucu id="kar-marj" />
                  <span className="ccd-muted"> — KDV hariç, müşteri PDF'inde görünmez
                    {bilinmeyen > 0 && ` · ${bilinmeyen} satırın alış iskontosu bilinmiyor, kâra dahil değil`}</span>
                </span>
              );
            })()}
            {tavanAsan > 0 && (
              <span className="ccd-kpi-down">
                {tavanAsan} satır iskonto tavanını aşıyor — kayıt engellenmez, iz bırakılır.
              </span>
            )}
          </div>
          <table className="ccd-table" style={{ width: 'auto' }}>
            <tbody>
              <tr>
                <td className="ccd-td ccd-label" data-fihrist="teklif-toplam">Ara toplam <Ipucu id="teklif-toplam" /></td>
                <td className="ccd-td ccd-td-num">{formatTl(araToplam)}</td>
              </tr>
              <tr>
                <td className="ccd-td ccd-label" data-fihrist="kdv-haric-dahil">KDV <Ipucu id="kdv-haric-dahil" /></td>
                <td className="ccd-td ccd-td-num">{formatTl(kdvToplam)}</td>
              </tr>
              <tr>
                <td className="ccd-td ccd-label" data-fihrist="teklif-toplam"><b>Genel toplam</b></td>
                <td className="ccd-td ccd-td-num">
                  <span className="ccd-metric" style={{ fontSize: 22 }}>
                    {formatTl(araToplam + kdvToplam)}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Kaydet + durum */}
      <div className="ccd-row-between" style={{ flexWrap: 'wrap', gap: 12 }}>
        <div className="ccd-row" style={{ flexWrap: 'wrap' }}>
          {can('quote.write') && d.status === 'TASLAK' && satirlar.length > 0 && (
            <button className="ccd-btn ccd-btn-sm" onClick={() => durumDegistir('GONDERILDI')}>
              Gönderildi işaretle
            </button>
          )}
          {can('quote.write') && d.status === 'GONDERILDI' && (
            <>
              <button className="ccd-btn ccd-btn-accent ccd-btn-sm" onClick={() => durumDegistir('ONAYLANDI')}>
                Satışa döndü
              </button>
              <button className="ccd-btn ccd-btn-danger ccd-btn-sm" onClick={() => durumDegistir('KAYBEDILDI')}>
                Kaybedildi
              </button>
            </>
          )}
        </div>
        {yazabilir && !telefon && (
          <button className="ccd-btn ccd-btn-primary ccd-btn-lg" onClick={kaydet} disabled={bekliyor}>
            {bekliyor
              ? 'Kaydediliyor…'
              : `${kirli ? 'Değişiklikleri kaydet' : 'Teklifi kaydet'} · ${formatTl(araToplam + kdvToplam)}`}
          </button>
        )}
      </div>
      {/* Telefon: toplam + Kaydet + PDF ekranın altında sabit (alt gezinme çubuğunun üstünde). */}
      {hazirPdf && (
        <div className="ccd-banner" role="status">
          <span className="ccd-banner-icon" aria-hidden="true">✓</span>
          <div className="ccd-row" style={{ flexWrap: 'wrap', gap: 8 }}>
            <span><b>PDF hazır.</b> {hazirPdf.ad}</span>
            <button type="button" className="ccd-btn ccd-btn-primary ccd-btn-sm"
                    onClick={() => void dosyaPaylas(hazirPdf.blob, hazirPdf.ad, `Teklif ${d.no}`).then((r) => { if (r !== 'izin') setHazirPdf(null); })}>Paylaş</button>
            <button type="button" className="ccd-btn ccd-btn-sm" onClick={() => {
              const url = URL.createObjectURL(hazirPdf.blob); const a = document.createElement('a');
              a.href = url; a.download = hazirPdf.ad; a.click(); URL.revokeObjectURL(url); setHazirPdf(null);
            }}>İndir</button>
          </div>
        </div>
      )}
      {telefon && (
        <div className="ccd-eylem-cubuk" role="region" aria-label="Teklif toplamı ve eylemler">
          <div className="ccd-eylem-toplam">
            <span>{satirlar.length} satır{kirli && yazabilir ? ' · kaydedilmedi' : ''}</span>
            <b>{formatTl(araToplam + kdvToplam)}</b>
          </div>
          {hazirPdf ? (
            <button type="button" className="ccd-btn ccd-btn-accent"
                    onClick={() => void dosyaPaylas(hazirPdf.blob, hazirPdf.ad, `Teklif ${d.no}`).then((r) => { if (r !== 'izin') setHazirPdf(null); })}>Paylaş</button>
          ) : (
            <button type="button" className="ccd-btn" onClick={() => void pdfIndir(true)} disabled={pdfBekliyor || satirlar.length === 0}
                    title="Müşteri PDF'i: paylaşım sayfası açılır">{pdfBekliyor ? '…' : 'PDF'}</button>
          )}
          {yazabilir && (
            <button type="button" className="ccd-btn ccd-btn-primary" onClick={() => void kaydet()} disabled={bekliyor}>
              {bekliyor ? 'Kaydediliyor…' : 'Kaydet'}
            </button>
          )}
        </div>
      )}
      {vadeTanimAcik && (
        <VadeCekmece kapat={() => setVadeTanimAcik(false)}
                     eklendi={(yeni, liste) => { setVadeler(liste); setVadeId(yeni.id); setVadeTanimAcik(false); }} />
      )}
    </>
  );
}
